import React from 'react';
import Modal from './Modal';
import * as Ons from 'react-onsenui';
import { translate as _ } from '../util/i18n';

class PlayerImage extends React.Component {

    constructor( props ) {

        super( props );

        this.state = {
            imgError:       props.player.imageUrl ? false : true,
            largeImageOpen: false
        };

        this.handleImageLoadingError     = this.handleImageLoadingError.bind( this );
        this.handleClick                 = this.handleClick.bind( this );
        this.handleJerseyNrClick         = this.handleJerseyNrClick.bind( this );
        this.handleLargeImageClick       = this.handleLargeImageClick.bind( this );
        this.handleLargeImageToggleClick = this.handleLargeImageToggleClick.bind( this );

    }

    handleImageLoadingError() {

        this.setState( { imgError: true } );

    }

    handleClick( e ) {

        e.stopPropagation();

        this.setState( { largeImageOpen: true } );

    }

    handleJerseyNrClick() {

        this.props.onJerseyNrClick();

    }

    handleLargeImageClick( e ) {

        e.stopPropagation();

        this.setState( { largeImageOpen: false } );

    }

    handleLargeImageToggleClick( e ) {

        e.stopPropagation();

        this.props.onToggle && this.props.onToggle();

    }

    render() {

        // console.log( 'components.PlayerImage.render()', this.props, this.state );

        return (

            <>

                <div className={'player-image' + ( this.state.imgError ? ' none' : '' )} onClick={this.handleClick}>

                    {!this.props.player.imageUrl || this.state.imgError ? <div>{this.props.type === 'Players' ? ( this.props.player.jerseyNr || '##' ) : <Ons.Icon icon="fa-user" />}</div> : <img src={this.props.player.imageUrl} alt='' onError={this.handleImageLoadingError} />}

                </div>

                { this.state.largeImageOpen &&

                    <Modal>

                        <div className="large-player-image" style={{ backgroundImage: 'url("' + this.props.player.imageUrl + '")' }} onClick={this.handleLargeImageClick}>

                            <div className="player-name">

                                <span className="player-lastname">{this.props.player.lastname}</span>
                                <span className="player-firstname">{this.props.player.firstname}</span>
                                <span className="player-middlename">{this.props.player.middlename}</span>

                            </div>

                            {( !this.props.player.imageUrl || this.state.imgError ) && <div className="none">{_( 'Kein Foto vorhanden' )}</div>}

                            {this.props.type === 'Players' && <div className="jersey-nr" onClick={this.handleJerseyNrClick}>#{this.props.player.jerseyNr}</div>}

                            {this.props.activatable && <div className="toggle"><Ons.Button onClick={this.handleLargeImageToggleClick}>{this.props.isActive ? this.props.textIsActive : this.props.textActivate}</Ons.Button></div>}

                        </div>

                    </Modal>

                }

            </>

        );

    }

}

export default PlayerImage;